export class TableInfoHeader {
    public text: string;
    public sortEnabled: boolean;
    public selected: boolean;
    public sortAsc: boolean; // true: asc, false: desc, null: not set

    constructor(text: string, sortEnabled: boolean, sortAsc: boolean, selected: boolean) {
        this.text = text;
        this.sortEnabled = sortEnabled;
        this.selected = selected;
        this.sortAsc = sortAsc;
    }
}
